import { GoogleGenerativeAI } from '@google/generative-ai';

const apiKey = import.meta.env.VITE_GEMINI_API_KEY;

let genAI: GoogleGenerativeAI | null = null;

if (apiKey) {
  genAI = new GoogleGenerativeAI(apiKey);
}

export interface CustomerSummaryData {
  customer: {
    name: string;
    address?: string | null;
    primary_contact_name?: string | null;
  };
  activeProducts: Array<{ name: string; cost: number; type: string }>;
  devices: Array<{ name: string; type: string; status: string }>;
  mrr: number;
  billingStatus: Array<{ month: string; status: string }>;
}

export const generateCustomerSummary = async (
  customerData: CustomerSummaryData
): Promise<string> => {
  if (!genAI) {
    return 'AI summary not available. Please configure your Gemini API key.';
  }

  try {
    const model = genAI.getGenerativeModel({ model: 'gemini-1.5-flash' });

    const prompt = `
      You are an expert IT Managed Service Provider (MSP) strategist. 
      Analyze the following customer profile and provide a professional, concise executive summary.
      
      Focus on these three specific areas in a bulleted list:
      1. Business Health & MRR: Summary of active services and monthly recurring revenue.
      2. Infrastructure Status: Assessment of device health, count, and types.
      3. Action Items & Risks: Highlight any immediate risks (overdue bills, expired products, or lack of critical systems like MFA/backups).

      Keep your response concise - maximum 150 words.

      Customer Profile: ${JSON.stringify(customerData)}
    `;

    const result = await model.generateContent(prompt);
    const response = await result.response;
    return response.text() || 'No summary generated.';
  } catch (error) {
    console.error('Gemini API Error:', error);
    return 'Failed to generate summary. Please check your API configuration.';
  }
};

export const isAIAvailable = (): boolean => {
  return !!genAI;
};
